<!-- Impersonation Banner - Only shown when impersonating -->
<!-- Uses position:sticky instead of fixed to properly push content down -->
<div *ngIf="impersonatedUser" 
     class="sticky top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 text-white shadow-lg">
  <div class="container mx-auto px-4">
    <div class="flex items-center justify-between py-2">
      <!-- Left side: Icon and message -->
      <div class="flex items-center gap-3">
        <!-- Mask icon -->
        <div class="flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        </div>
        
        <!-- Message -->
        <div class="flex items-center gap-2 text-sm font-medium">
          <span class="hidden sm:inline">🎭</span>
          <span>
            <span class="font-bold">Impersonation Mode</span>
            <span class="hidden sm:inline"> — </span>
            <span class="hidden sm:inline">Viewing as</span>
          </span>
          <span class="bg-white/20 px-2 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide">
            {{ getUserTypeLabel() }}
          </span>
        </div>
        
        <!-- User info -->
        <div class="flex items-center gap-2 bg-black/20 rounded-lg px-3 py-1">
          <div class="w-6 h-6 bg-white/30 rounded-full flex items-center justify-center text-xs font-bold">
            {{ impersonatedUser.name?.charAt(0)?.toUpperCase() || impersonatedUser.email?.charAt(0)?.toUpperCase() }}
          </div>
          <div class="flex flex-col">
            <span class="text-sm font-semibold leading-tight">{{ impersonatedUser.name || 'Unknown' }}</span>
            <span class="text-xs opacity-80 leading-tight hidden sm:block">{{ impersonatedUser.email }}</span>
          </div>
        </div>

        <!-- Company info (if available) -->
        <div *ngIf="impersonatedUser.companyName" class="hidden md:flex items-center gap-1 text-xs opacity-80">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          <span>{{ impersonatedUser.companyName }}</span>
        </div>
      </div>

      <!-- Right side: Exit button -->
      <button 
        (click)="stopImpersonation()"
        class="flex items-center gap-2 bg-white text-orange-600 hover:bg-orange-100 px-4 py-1.5 rounded-lg font-semibold text-sm transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        <span class="hidden sm:inline">Exit Impersonation</span>
        <span class="sm:hidden">Exit</span>
      </button>
    </div>
  </div>
</div>

